import { useRef, useEffect } from 'react';
import throttle from 'raf-throttle';
import { isSSR } from './ssr';
const getScrollPosition = () => (isSSR ? 0 : window.pageYOffset);
export const useScrollPosition = (callback, deps = []) => {
    const scrollPosition = useRef(getScrollPosition());
    useEffect(() => {
        if (isSSR)
            return;
        const handleScroll = throttle(() => {
            const updatedScrollPosition = getScrollPosition();
            callback({
                prevScrollPosition: scrollPosition.current,
                currScrollPosition: updatedScrollPosition
            });
            scrollPosition.current = updatedScrollPosition;
        });
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, deps);
};
